import tidalLink from './components/tidal-link.vue';

export { tidalLink };
